export const getMedianToken = async () => {
  if (navigator.userAgent.indexOf("median") > -1 || window.median !== undefined) {
    return window.median?.storage?.app
      .get({
        key: "token",
      })
      .then(function (result) {
        if (result.data) {
          localStorage.setItem("token", result.data);
          return true;
        } else {
          return false;
        }
      });
  } else {
    return false;
  }
};
